/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { css, jsx } from '@emotion/core'
import { sectionCss } from './style'
import React from 'react'
import { getState, Disclosures } from '../twd'

const items = require('./resources.json')

const state = getState('municipals.resources', {
    tab: 'why',
    index: 0
})

export default () => {
    const [tab, setTab_] = React.useState(state.value.tab || 'why')
    const setTab = React.useCallback((m) => {
        state.set({tab:m})
        setTab_(m)
    }, [])

    const [index, setIndex_] = React.useState(state.value.index || -1)
    const setIndex = React.useCallback((m) => {
        state.set({index:m})
        setIndex_(m)
    }, [])

    const tabItems = items[tab] || []

    return (
    <React.Fragment>
    <div id='municipal-bond-resources' className="vertical-offset-sm"></div>
    <div className="container vertical-offset-sm" css={sectionCss}>

        <div className="row vertical-offset-sm"></div>

        <div className="row"><div className="col-xs-12">
            <h3 className="medium-header" style={{marginBottom:0}}>Municipal Bond Resources</h3>
        </div></div>

        <div className="row vertical-offset-sm"><div className="col-xs-12">
        <div data-name='municipals-bond-resources-nav-tabs' className="nav-tabs">
            <ul>
                <li className={tab==='why' ? 'active' : ''}>
                <button
                    data-name='municipals-bond-resources-why-invest-nav-tab'
                    className="subhead" onClick={() => setTab('why')}>Why invest?</button>
                </li>

                <li className={tab==='faq' ? 'active' : ''}>
                <button
                    data-name='municipals-bond-resources-faq-nav-tab'
                    className="subhead" onClick={() => setTab('faq')}>FAQ</button>
                </li>

                <li className={tab==='risk' ? 'active' : ''}>
                <button
                    data-name='municipals-bond-resources-risks-nav-tab'
                    className="subhead" onClick={() => setTab('risk')}>Risks</button>
                </li>
            </ul>
            </div>
        </div></div>

        { Array.isArray(tabItems) ? renderItems(tabItems, index, setIndex) : (
            <div className="row vertical-offset-sm">
            <div className="col-md-12" dangerouslySetInnerHTML={{__html:tabItems}} />
            </div>
        )}
    </div>
    </React.Fragment>)
}

const renderItems = (items, index, setIndex) => items.map((item, idx) => {
    let [title, content, disclosure] = item
    let showItem = idx === index
    return <React.Fragment key={idx}>
        <div>
        <button
            data-name='municipals-bond-resources-item-arrow'
            style={{position:'relative', top:-2, zIndex:1}}
            className="btn-link text-muted"
            onClick={() => setIndex(showItem ? -1 : idx)}>
        <i style={{color:'var(--primary-base-color)'}} className="material-icons">{
            showItem ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
        }</i>
        </button>

        <div style={{position:'relative', top:'-20px', paddingLeft:20}}>
        <button
            data-name='municipals-bond-resources-item-title'
            className={ "btn-link text-muted" + (showItem ? " vertical-offset-sm" : '') }
            onClick={() => setIndex(showItem ? -1 : idx)}>
        <b style={{color:'var(--primary-base-color)'}}><span>{title}</span></b>
        </button>

        {showItem && <div css={itemCss} dangerouslySetInnerHTML={{__html:content}} />}
        {showItem && disclosure && <div className="text-right">
            <Disclosures html={disclosure} />
            </div>}
        </div>
        </div>

    </React.Fragment>
})

const itemCss = css`{

    'li': {
        'padding-left': '10px'
    },
    'img': {
        'max-width': '100%'
    }
}`


// WEBPACK FOOTER //
// ./src/municipals/resources.js